<div class="backups">
  @if (backups$ | async; as records) {
    <div class="filters">
      <app-date-picker
        id="date-picker"
        label="Backup Date"
        placeholder="DD/MM/YYYY"
        type="range"
        [formControl]="dateRange"
      ></app-date-picker>

      <button matButton="outlined" (click)="clearFilters()">
        <fa-icon [icon]="['fas', 'filter-circle-xmark']" size="lg"></fa-icon>
        Clear Filter
      </button>
    </div>

    <div class="table-container">
      <div class="header">
        <h2>Website backups</h2>
      </div>

      <mat-card appearance="outlined" class="table-inner">
        <app-table
          #table
          [columns]="backupsColumns"
          [dataSource]="records"
          [totalCount]="allBackupsCount()"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [status]="toStatus(element.status)"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <button
                  matRipple
                  class="button"
                  matTooltip="Restore Backup"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="restoreBackup(element)"
                >
                  <fa-icon [icon]="['fas', 'arrow-rotate-left']" size="lg"></fa-icon>
                </button>
                <button
                  matRipple
                  class="button"
                  matTooltip="Backup Details"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="showDetails(element)"
                >
                  <fa-icon [icon]="['fas', 'circle-info']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </app-table>
      </mat-card>
    </div>
  }
</div>
